/**
 * FormInput Component with Validation
 */

import { Typography } from '@/src/shared/ui/typography/Typography';

interface FormInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  type?: 'text' | 'email' | 'tel' | 'number';
  hint?: string;
  name?: string;
}

export function FormInput({
  label,
  value,
  onChange,
  error,
  placeholder,
  required = false,
  disabled = false,
  type = 'text',
  hint,
  name,
}: FormInputProps) {
  return (
    <div className="form-field" data-field={name}>
      <label className="flex items-center gap-1 mb-2">
        <Typography variant="body" weight="medium">
          {label}
        </Typography>
        {required && <span className="text-feedback-error">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-full px-5 py-3 border rounded-2xl focus:outline-none focus:ring-2 transition-all ${
          disabled
            ? 'bg-gray-100 cursor-not-allowed'
            : 'bg-white'
        } ${
          error
            ? 'border-feedback-error focus:ring-feedback-error ring-2 ring-feedback-error/20'
            : 'border-border-primary focus:ring-accent-primary'
        }`}
      />
      {error && (
        <Typography variant="bodySm" className="text-feedback-error mt-1 font-medium">
          {error}
        </Typography>
      )}
      {hint && !error && (
        <Typography variant="bodySm" color="secondary" className="mt-1">
          {hint}
        </Typography>
      )}
    </div>
  );
}
